import ManIcon from '@mui/icons-material/Man';
import WomanIcon from '@mui/icons-material/Woman';
export const userColumns = [
    {
        field: "name",
        headerName: "Name",
        width: 150,
    },
    {
        field: "gender",
        headerName: "Gender",
        width: 100,
        renderCell: (params) => {
          return (
            <div className="cellWithImg">
              {
                params?.row?.gender === "Male" ? <><ManIcon style={{ color: "blue"}} />{params.row.gender} </>: 
                params?.row?.gender === "FeMale" ? <WomanIcon style={{ color: "pink"}}/> : "Others"
              }
              
            </div>
          );
        },
      },
    {
        field: "age",
        headerName: "Age",
        width: 150,
    },
    {
        field: "mobile",
        headerName: "Mobile",
        width: 150,
    },
    {
        field: "address",
        headerName: "Address",
        width: 150,
    },
    {
        field: "billingMode",
        headerName: "Billing Mode",
        width: 150,
    },
    

];